module.exports = __webpack_public_path__ + "img/visa.3c059de8.png";